/** @format */
import Image from 'next/image';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import {useEffect, useReducer, useCallback} from 'react';

import {useGoodCause} from '@context/GoodCauseProvider';
import {useApp} from '@context/AppProvider';
import Loading from '@components/Loading';
import styles from '@styles/mygoodcause/mygoodcause.module.scss';
// eslint-disable-next-line import/order
import {init, reducer} from '@reducers/mygoodcause';
const CommonBreadcrumbs = dynamic(() =>
	import('@components/common/CommonBreadcrumbs'),
);
const MessageComponent = dynamic(() =>
	import('@components/common/MessageComponent'),
);

import SeoMeta from '@components/common/seo';

const Form = dynamic(() => import('./Form'));
import {getAllCharities} from './js/function';

const breadcrumbs = [
	{name: 'My Account', href: '/my-account'},
	{name: 'My Good Cause', href: ''},
];

function MyGoodCause() {
	const {
		idb: {session, user},
	} = useApp();
	const {gc} = useGoodCause();

	const [state, dispatch] = useReducer(reducer, init);
	const getCharities = useCallback(
		async (user, session) => {
			const charitDt = await getAllCharities(session, user, gc);

			dispatch({
				type: 'set_charityData',
				charities: charitDt?.charities,
				userCharityId: charitDt?.userCharityId,
				goodCauseName: charitDt?.goodCauseName,
				goodCauseImage:
					charitDt?.goodCauseImage || '/assets/svg/placeholder.svg',
				goodCauseMessage: charitDt?.goodCauseMessage,
				Parentcharityid: charitDt?.Parentcharityid,
				loading: false,
			});
		},
		[gc],
	);

	useEffect(() => {
		if (user?._id) {
			getCharities(user, session);
		}
	}, [getCharities, user, session]);

	const showMoreFunction = val => {
		dispatch({
			type: 'set_showMore',
			showMore: val,
		});
	};

	return (
		<>
			<SeoMeta title={'My Good Cause'} url={'my-good-cause'} />
			<div className={styles.myGoodCause}>
				<CommonBreadcrumbs breadcrumbs={breadcrumbs}></CommonBreadcrumbs>
				<div className={styles.heading}>
					<h2>My Good Cause</h2>
				</div>
				<div className={`${styles.myGoodCausePg} row justify-content-center`}>
					{state.message && (
						<MessageComponent
							message={state.message}
							messageKey={state.messageKey}
						></MessageComponent>
					)}
					<div
						className={`${styles.myGoodCausePgHeader} col-sm-12 text-center`}
					>
						{user?._id &&
							state.Parentcharityid &&
							state.goodCauseName &&
							!state.goodCauseMessage && (
								<p className={styles.removePTMgBottom}>
									{state.goodCauseName.replace(/ *\([^)]*\) */g, '')} is your
									selected good cause which Better That will donate to each time
									you shop.
								</p>
							)}
						{user?._id &&
							state.Parentcharityid &&
							state.goodCauseName &&
							state.goodCauseMessage && (
								<p className={styles.removePTMgBottom}>
									Your good cause is{' '}
									{state.goodCauseName.replace(/ *\([^)]*\) */g, '')}
								</p>
							)}

						{user?._id && !state.Parentcharityid && (
							<p className={styles.removePTMgBottom}>
								You have not yet selected a good cause to donate to when you
								shop.
							</p>
						)}

						{user?._id && state.Parentcharityid && (
							<div className={`${styles.goodCauseImage} col-md-6`}>
								<Image
									layout='fill'
									className={styles.image}
									src={state.goodCauseImage}
									alt={state.goodCauseName}
									quality={80}
									placeholder='blur'
									blurDataURL='/assets/images/dual_ball.gif'
									priority={true}
								/>
							</div>
						)}
						{user?._id && state.Parentcharityid && !state.showMore && (
							<p className={`${styles.paragraph} links`}>
								You can change your good cause at any time by
								<span
									className={`${styles.clickHere}`}
									onClick={() => showMoreFunction(true)}
								>
									{' '}
									clicking here.
								</span>
							</p>
						)}

						{user?._id && state.Parentcharityid && state.showMore && (
							<p className={`${styles.paragraph} links`}>
								Change your cause by selecting Good cause from the down down
								below and press save.
							</p>
						)}
					</div>
				</div>
				{((!state.loading && user?._id && !state.Parentcharityid) ||
					state.showMore) && (
					<Form styles={styles} state={state} dispatch={dispatch} />
				)}

				<p className={`${styles.bottomParagraph}`}>
					You can also nominate a new one by completing the form on
					<Link href='/give'>
						<a target='_blank'> this page. </a>
					</Link>
				</p>
				<p className={styles.bottomParagraph}>
					Learn more about all our
					<Link href='/good-causes'>
						<a target='_blank'> good causes </a>
					</Link>
					and the important work that they do.
				</p>
				{state.loading && <Loading />}
			</div>
		</>
	);
}

export default MyGoodCause;
